module.exports = __webpack_public_path__ + "static/media/arrangements1.5415a261.jpg";